import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: "/estimate/img/logo.png",
  alt: ""
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://showa-metal.jp/inquiry_contact2019-001/",
  target: "_blank"
}, "お問い合わせ", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<li class=\"q-mx-md\"><a href=\"https://showa-metal.jp/\" target=\"_blank\">有限会社昭和メタル</a></li><li class=\"q-mx-md\"><a href=\"https://showa-metal.jp/law/\" target=\"_blank\">特定商取引法に基づく表示</a></li><li class=\"q-mx-md\"><a href=\"https://showa-metal.jp/privacy/\" target=\"_blank\">プライバシーポリシー</a></li>", 3)
const _hoisted_7 = [
  _hoisted_4
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, "Copyright © showa-metal .co.,Ltd All Rights Reserved.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['layout--header'])
    }, [
      _createElementVNode("header", {
        class: _normalizeClass(_ctx.$style.header)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['header--logo'])
        }, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['header--contact'])
        }, _hoisted_3, 2)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['layout--main'])
    }, [
      _createElementVNode("main", {
        class: _normalizeClass(["container", _ctx.$style.main])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style['main--inner'])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 2)
      ], 2)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['layout--footer'])
    }, [
      _createElementVNode("footer", {
        class: _normalizeClass(_ctx.$style.footer)
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("ul", {
            class: _normalizeClass([_ctx.$style['footer--navList'], "flex justify-center"])
          }, _hoisted_7, 2)
        ]),
        _hoisted_8
      ], 2)
    ], 2)
  ], 64))
}